import { useCallback } from 'react'
import { useAuthStore } from '@/stores/authStore'
import type { User } from '@/types'

export interface UseAuthResult {
  user: User | null
  isSignedIn: boolean
  loading: boolean
  error: string | null
  signOut: () => Promise<void>
  refreshUser: () => Promise<void>
}

export function useAuth(): UseAuthResult {
  const user = useAuthStore((s) => s.user)
  const loading = useAuthStore((s) => s.loading)
  const error = useAuthStore((s) => s.error)
  const fetchUser = useAuthStore((s) => s.fetchUser)
  const logout = useAuthStore((s) => s.logout)

  const signOut = useCallback(async () => {
    logout()
  }, [logout])

  return {
    user,
    isSignedIn: !!user,
    loading,
    error,
    signOut,
    refreshUser: fetchUser,
  }
}
